import { CheckButton, CheckButtonFontStyle, CheckButtonStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../../../../state/standardLoanStore';

/** Checking it sets Apprvd Loan Amt and Bridge Funded to Prom. Note/Com. (setSameAsCommitted applies that). */
export const SameAsCommittedField = () => {
    const sameAsCommitted = useStandardLoanStore((state) => state.sameAsCommitted);
    const setSameAsCommitted = useStandardLoanStore((state) => state.setSameAsCommitted);

    return (
        <CheckButton
            id='loanSameAsCommitted'
            fontStyle={CheckButtonFontStyle.Small}
            checkButtonStyle={CheckButtonStyle.Plain}
            selected={sameAsCommitted}
            onToggle={() => setSameAsCommitted(!sameAsCommitted)}
            label='Same as Committed'
            width='200px'
        />
    );
};
